<!--
 * @Description: 编辑活码页面
 * @Author: mdb
 * @Date: 2023-04-17 16:10:58
 * @LastEditTime: 2023-04-19 16:34:30
 * @LastEditors: mdb
-->
<template>
  <dc-layout-main>
    <dc-layout-content>
      <DetailForm type="edit" :title="t('marketing.编辑市场活动')" paramCode="ofbu_source_channel" subdomain="ofbu" />
    </dc-layout-content>
  </dc-layout-main>
</template>

<script setup lang="ts">
import DetailForm from './components/DetailForm.vue'
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
</script>
<script lang="ts">
export default { name: 'DcCosOFbuActivityCodeEdit' }
</script>

<style scoped></style>
